import { Node, mergeAttributes } from "@tiptap/core";

export interface PastedContentAttrs {
  id: string;
  wordCount: string;
}

export const PastedContent = Node.create({
  name: "pastedContent",
  group: "inline",
  inline: true,
  atom: true,

  addAttributes() {
    return {
      id: { default: null },
      wordCount: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-type="pasted-content"]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(HTMLAttributes, {
        "data-type": "pasted-content",
        "data-id": node.attrs.id,
        class: "pasted-content-node",
      }),
      `Pasted ${node.attrs.wordCount} words`,
    ];
  },

  renderText({ node }) {
    return `~~pasted~~[${node.attrs.wordCount}](${node.attrs.id})`;
  },
});
